export default __webpack_public_path__ + "627e461d2f23e2dd934d4106878421e6.png";